import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import ArticleModalWithDatatable from '../article/ArticleModalWithDatatable';
import DocumentModalWithDatatable from '../document/DocumentModalWithDatatable';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import NumberFormat from 'react-number-format';
import CustomSelect from '../../components/custom-select/CustomSelect';
import * as RestService from '../../services/eisRest';
import moment from 'moment';
import 'moment/locale/sk';
import DatePicker, { registerLocale } from "react-datepicker";
import MultiselectCheckbox from './MultiselectCheckbox';
import sk from 'date-fns/locale/sk';
import "react-datepicker/dist/react-datepicker.css";
registerLocale('sk', sk)




  const ProcessingModal = (props) => {

   

    const [t] = useTranslation();      
    const {i18n} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);    
    const [workOrderId, setWorkOrderId] = useState();
    const [operationId, setOperationId] = useState();
    
    const [processOperation, setProcessOperation] = useState(null);  
    const [openAlertDialog, setOpenAlertDialog] = useState(false);    
    const dialogRef = createRef();

    const [selectedRecord, setSelectedRecord] = useState(null);
    const [workOrder, setWorkOrder] = useState([]);
    const [workOrderItem, setWorkOrderItem] = useState([]);
    const [workOrderSnList, setWorkOrderSnList] = useState([]);
    const [snList, setSnList] = useState(null);
    
    const [qtyOrd, setQtyOrd] = useState(0);
    const [qtyOk, setQtyOk] = useState(0);
    const [qtyNok, setQtyNok] = useState(0);
    const [durationMachine, setDurationMachine] = useState(0);
    const [durationOperator, setDurationOperator] = useState(0);
    const [okOrNok, setOkOrNok] = useState('OK');
    
    const options = [{ label: 'Item One' }, { label: 'Item Two' }];


    const processTypeOptions = [
      { value: 'DEFAULT_VALUES', label: 'DEFAULT_VALUES' },
      { value: 'CHANGED_VALUES', label: 'CHANGED_VALUES' }
      
    ];

    const okOrNokOptions = [
      { value: 'OK', label: 'OK' },
      { value: 'NOK', label: 'NOK' }
      
    ];
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus,operationId);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };


    const loadProcessOperation = () => {
      RestService.callAnyApi('workOrder/getProcessOperation?id='+props.selectedRecord, null)
      .then((data) => {     
        if(data.id){               
          setQtyOk(data.qtyOk);
          setQtyNok(data.qtyNok);
          RestService.callAnyApi('workOrder/getWorkOrderSnList?workOrderId='+props.workOrderId+"&processOperationId="+props.selectedRecord, null).then((data) => {
            setWorkOrderSnList(data);
          }).catch((error) => {
          
          }); 
        }else{
          setQtyOk(0);
          setQtyNok(0);
          
        }
        setProcessOperation(data); 
      })
      .catch((error) => {
        console.log(error);
      });

    }

    useEffect(() => {          
      setIsOpen(props.modal);
      showChanged(props.modal);
      RestService.callAnyApi('workOrder/getWorkOrder?id='+props.workOrderId, null)
      .then((data) => {          
        setWorkOrder(data); 
        setQtyOrd(data.qtyOrd);      
        if(data && data.workOrderItems){

          data.workOrderItems.map((workOrderItem, index) => {
            if(workOrderItem.id===props.operationId){
              setWorkOrderItem(workOrderItem);              
              setDurationMachine(workOrderItem.durationMachine ? workOrderItem.durationMachine : 0);
              setDurationOperator(workOrderItem.durationOperator ? workOrderItem.durationOperator : 0);
              formik.setFieldValue('processType','DEFAULT_VALUES');

              
              if(typeof(props.workOrderId) !== 'undefined' && props.workOrderId!==''){
                  
                  RestService.callAnyApi('workOrder/getWorkOrderSnList?workOrderId='+props.workOrderId+"&workOrderItemId="+props.operationId, null).then((data) => {
                      setWorkOrderSnList(data);
                  }).catch((error) => {
                    
                  }); 
              }

            }
          }

        );
        }
      //  if(processOperation==null || processOperation.id===null){
          loadProcessOperation();
       // }
      })
      .catch((error) => {
        console.log(error);
      });

     
  
    
    }, [props.modal])



   
    useEffect(() => {      
      setOperationId(props.operationId);    
    }, [props.operationId])

    useEffect(() => {      
      setWorkOrderId(props.workOrderId);              
    }, [props.workOrderId])

    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);    
    }, [props.selectedRecord])
    

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK' && processOperation && processOperation.id){
        RestService.callAnyApi('basic/deleteRecord?entity=processOperation&id='+processOperation.id, null).then(
          (data) => {           
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      
    }


    

    const handleCheckboxListChange = (values) => {
      // values is array of selected item. e.g. ['apple', 'banana']
    }
    
    const handleChange = (e,elementName) => {
      
      if(processOperation!=null){
          switch(elementName){              
              case "qtyOk":
                processOperation.qtyOk=e.floatValue;    //number     
                setQtyOk(e.floatValue);
              break;  
              case "qtyNok":
                processOperation.qtyNok=e.floatValue;    //number     
                setQtyNok(e.floatValue);
              break;  
              case "durationMachine":
                processOperation.durationMachine=e.floatValue;    //number     
                setDurationMachine(e.floatValue);
              break;  
              case "durationOperator":
                processOperation.durationOperator=e.floatValue;    //number     
                setDurationOperator(e.floatValue);
              break;  
              default:
          }          
      }
  };

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

   
    const save = (url,values) => {
    
      if(workOrder!==null && workOrderItem!==null){
        let minusQty=0;
        if(processOperation && processOperation.id){minusQty=(processOperation.qtyOk+processOperation.qtyNok)*-1;}
        if((workOrderItem.qtyOk+workOrderItem.qtyNok+qtyOk+qtyNok+minusQty)>workOrder.qtyOrd){
          showError(null,t('general.message.maximumOrderedQtyExceeded'));
          return;
        }
        

      }else{
        showError(null,t('general.message.failed'));
        return;
      }

      processOperation.workOrderId = workOrder.id;
      processOperation.workOrderItemId = workOrderItem.id;
      processOperation.qtyOk = qtyOk;
      processOperation.qtyNok = qtyNok;
      processOperation.processType = values.processType;
      processOperation.description = values.description;
      processOperation.durationMachine = durationMachine;
      processOperation.durationOperator = durationOperator;
      processOperation.workOrder = null;
      processOperation.workOrderItem = null;
      processOperation.snList = snList;


     
      RestService.callAnyApi(url, processOperation)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
        name: workOrderItem ? workOrderItem.name : '',
        nbr: workOrderItem ? workOrderItem.nbr : '',
        processType:  processOperation ? processOperation.processType : 'DEFAULT_VALUES',
        
      //  nbr:  processOperation ?  processOperation.nbr  : '',             
        description: processOperation ? processOperation.description : ''
        
      },
      validationSchema: Yup.object({
        
   
          
      }),
      onSubmit: (values) => {           
          save('workOrder/saveProcessOperation',values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('workOrder.label.processOperation')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                           <div className="row">       
                          
                                <div className="col-6 col-sm-6 col-lg-6">

                                                                            
                                          <div className="row">       
                                                                    
                                                                    <div className="col-12 col-sm-12 col-lg-12">

                                                          
                                                                      
                                                                            <div className="form-group">
                                                                              <label>{t('workOrder.label.operation')}</label>
                                                                              <input type="text" class="form-control" readOnly value='' {...formik.getFieldProps('name')} />
                                                                            </div>
                                                                            
                                                                      

                                                                    </div>
                                                        </div>

                                                        <div className="row">       
                                                        
                                                                      <div className="col-6 col-sm-6 col-lg-6">

                                                                        
                                                                            
                                                                                  <div className="form-group">
                                                                                    <label>{t('workOrder.label.numberShort')}</label>
                                                                                    <input type="text" class="form-control" readOnly value='' {...formik.getFieldProps('nbr')} />
                                                                                  </div>
                                                                                  
                                                                            

                                                                      </div>
                                                        </div>




                                                       
                                                      
                                                        <div className="row">

                                                              <div className="col-6 col-sm-6 col-lg-6">
                                                                      <div class="form-group">
                                                                        <label>{t('workOrder.label.requestType')}</label>                               
                                                                        <CustomSelect
                                                                              className='input'
                                                                              onChange={value=>formik.setFieldValue('processType',value.value)}
                                                                              value={formik.values.processType}
                                                                              options={processTypeOptions}     
                                                                        />                                
                                                                      </div>
                                                                      {formik.touched.processType && formik.errors.processType ? (
                                                                        <div style={{ color: 'red' }}>{formik.errors.processType}</div>
                                                                      ) : null} 
                                                                  </div>      
                                                            
                                                        </div>


                                                        <div class="row" style={formik && formik.values.processType==='CHANGED_VALUES' ? {} : { display: 'none' }} >

                                                              <div className="col-6 col-sm-6 col-lg-6">
                                                                  <div class="form-group">
                                                                    <label>{t('workOrder.label.durationMachine')}</label>                               
                                                                    <NumberFormat displayType='input'  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="0"   value={durationMachine ? durationMachine : 0} onValueChange={(values)  => {handleChange(values,"durationMachine")}} />                                                                                  
                                                                  </div>
                                                              </div>   


                                                              <div className="col-6 col-sm-6 col-lg-6">
                                                                  <div class="form-group">
                                                                    <label>{t('workOrder.label.durationOperator')}</label>                               
                                                                    <NumberFormat displayType='input'  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="0"   value={durationOperator ? durationOperator : 0} onValueChange={(values)  => {handleChange(values,"durationOperator")}} />                                                                                  
                                                                  </div>
                                                              </div>   



                                                        </div>    



                                </div>

                                <div className="col-1 col-sm-1 col-lg-1">

                                </div>

                                <div className="col-5 col-sm-5 col-lg-5">


                                                        <div class="row" style={workOrder && workOrder.article && workOrder.article.serialNumber===0 ? {} : { display: 'none' }}>

                                                            <div className="col-6 col-sm-6 col-lg-6">
                                                                <div class="form-group">
                                                                  <label>{t('workOrder.label.pcsOrd')}</label>                               
                                                                  <NumberFormat displayType='text'  className="form-control col-12 col-sm-12 col-lg-12"   decimalScale="0"   value={qtyOrd ? qtyOrd : 0}  />                                                                                  
                                                                </div>
                                                            </div>   

                                                        </div>                    
                                                        <div class="row" style={workOrder && workOrder.article && workOrder.article.serialNumber===0 ? {} : { display: 'none' }}>

                                                            <div className="col-6 col-sm-6 col-lg-6">
                                                                <div class="form-group">
                                                                  <label>{t('workOrder.label.pcsOk')}</label>                               
                                                                  <NumberFormat displayType='input'  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="0"   value={qtyOk ? qtyOk : 0} onValueChange={(values)  => {handleChange(values,"qtyOk")}} />                                                                                  
                                                                </div>
                                                            </div>   

                                                        </div>                    
                                                        <div class="row" style={workOrder && workOrder.article && workOrder.article.serialNumber===0 ? {} : { display: 'none' }}>

                                                            <div className="col-6 col-sm-6 col-lg-6">
                                                                <div class="form-group">
                                                                  <label>{t('workOrder.label.pcsNok')}</label>                               
                                                                  <NumberFormat displayType='input'  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="0"   value={qtyNok ? qtyNok : 0} onValueChange={(values)  => {handleChange(values,"qtyNok")}} />                                                                                  
                                                                </div>
                                                            </div>   

                                                            

                                                        </div>                  


                                                        <div className="row"  style={workOrder && workOrder.article && workOrder.article.serialNumber===1 ? {} : { display: 'none' }}>

                                                                <div className="col-6 col-sm-6 col-lg-6">
                                                                        <div class="form-group">
                                                                          <label>{t('workOrder.label.okOrNok')}</label>                               
                                                                          <CustomSelect
                                                                                className='input'
                                                                                onChange={value=>setOkOrNok(value.value)}
                                                                                value={okOrNok}
                                                                                options={okOrNokOptions}     
                                                                          />                                
                                                                        </div>
                                                                        {formik.touched.okOrNok && formik.errors.okOrNok ? (
                                                                          <div style={{ color: 'red' }}>{formik.errors.okOrNok}</div>
                                                                        ) : null} 
                                                                </div>      

                                                        </div>


                                                        <div class="row" style={workOrder && workOrder.article && workOrder.article.serialNumber===1 ? {} : { display: 'none' }}>

                                                            <div className="col-12 col-sm-12 col-lg-12">
                                                         
                                                                <div class="form-group">
                                                                  <label>{t('workOrder.label.snList')}</label>                               
                                                                  <div style={{maxHeight: '250px',maxWidth: '250px', overflowY: 'none', overflowX: 'auto'}}>
                                                                        <MultiselectCheckbox
                                                                              options={workOrderSnList}
                                                                              workOrderId={workOrder ? workOrder.id : ''}
                                                                              processOperationId={processOperation ? processOperation.id : ''}
                                                                              okOrNok={okOrNok}
                                                                              onChange={data => {
                                                                                                    //console.log(data);
                                                                                                    setSnList(data);
                                                                                                }}
                                                                        />
                                                                  </div>
                                                                </div>
                                                            </div>   


                                                        
                                                            
                                                        </div>                                       
                            

                                </div>

                          </div>



                          <div className="row">

                              <div className="col-12 col-sm-12 col-lg-12">
                                  <div className="form-group">
                                      <label>{t('general.label.description')}</label>
                                      <input type="text" class="form-control"  value=""  placeholder={t('general.label.description')} {...formik.getFieldProps('description')} />
                                  </div>
                                  {formik.touched.description && formik.errors.description ? (<div style={{ color: 'red' }}>{formik.errors.description}</div>) : null} 
                              </div>

                          </div>
                           
                         

                    </Modal.Body>
                    <Modal.Footer>                                                  
                          <Button style={processOperation && processOperation.id && workOrder && workOrder.status==='R' ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>
                          <Button style={workOrder && workOrder.status==='R' ? {} : { display: 'none' }}  className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 

                
      </>
    );
  };

 export default ProcessingModal;